import React from 'react';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

/**
 * Página de confirmação de redefinição de senha bem-sucedida
 */
export default function PasswordResetSuccessPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper elevation={3} sx={{ p: 4, minWidth: 320, maxWidth: 500, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />
        </Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Senha redefinida com sucesso!
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Sua senha foi atualizada. Agora você pode fazer login com sua nova senha.
        </Typography>
        <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/login')}>
          Ir para Login
        </Button>
      </Paper>
    </Box>
  );
}
